module.exports = __webpack_public_path__ + "img/vue2-corpsavant_gris.d7f487ae.png";